var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70709 0C5.47279 0 3.67988 1.53446 3.67988 4.4671C3.67988 6.38221 4.44266 8.33287 5.60091 9.53481C6.05266 10.7367 5.23803 11.1841 5.06918 11.2477C2.73121 12.1053 0 13.6605 0 15.2053V15.783C0 17.8884 4.00943 18.375 7.7293 18.375C8.54008 18.3736 9.35054 18.343 10.1591 18.2831C9.14664 17.2145 8.58351 15.7976 8.58614 14.3255C8.58614 12.9992 9.03789 11.7839 9.78882 10.8078C9.67774 10.5472 9.6333 10.1361 9.83548 9.51185C10.9871 8.30843 11.7336 6.3748 11.7336 4.46636C11.7336 1.53446 9.93842 0.000740569 7.70635 0.000740569L7.70709 0ZM14.3722 9.65034C13.1324 9.65034 11.9433 10.1429 11.0666 11.0196C10.1899 11.8963 9.69736 13.0853 9.69736 14.3252C9.69736 15.565 10.1899 16.7541 11.0666 17.6308C11.9433 18.5075 13.1324 19 14.3722 19C15.612 19 16.8011 18.5075 17.6778 17.6308C18.5545 16.7541 19.047 15.565 19.047 14.3252C19.047 13.0853 18.5545 11.8963 17.6778 11.0196C16.8011 10.1429 15.612 9.65034 14.3722 9.65034ZM13.7242 11.7336H15.0202V13.6546H16.9412V14.9965H15.0202V16.9175H13.7242V14.9965H11.7802V13.6546H13.7242V11.7336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.406b7b6c5abca2041827cf5466d53fde.svg";
export { ForwardRef as ReactComponent };